import bankPrepagoLosHeroes from '../../banksPNG/bankPrepagoLosHeroes.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoLosHeroesIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco los Heroes',
}: IconProps) => <img src={bankPrepagoLosHeroes} width={width} height={height} alt={alt} />;
